import Service from 'core/service'
import type { IProjectForm, IProjectSearchParams } from 'interfaces'

export class ProjectService extends Service {
  getListProjects(params: IProjectSearchParams): Promise<Project[]> {
    return this.get('/projects', params)
  }

  createProject(params: IProjectForm): Promise<Project> {
    return this.post('/projects', params)
  }

  updateProject(params: IProjectForm): Promise<Project> {
    return this.put(`/projects/${params.id}`, params)
  }

  deleteProject(id: string, company: string): Promise<Project> {
    return this.delete(`/companies/${company}/projects/${id}`)
  }

  getProjectByIds(company: string, projectIds: string): Promise<Project[]> {
    return this.get(`/projects/${company}/ids`, { projectIds })
  }
}
